import "@blocknote/core/fonts/inter.css";
import "@blocknote/shadcn/style.css";

import { useCreateBlockNote } from "@blocknote/react";
import { BlockNoteView } from "@blocknote/shadcn";
import { useMemo } from "react";
import { parseConceptContent, stripEmptyBlocks } from "./richTextUtils";

interface RichTextViewerProps {
  content: string | null | undefined;
  className?: string;
  variant?: "card" | "modal";
}

export function RichTextViewer({ content, className, variant = "modal" }: RichTextViewerProps) {
  const blocks = useMemo(
    () => stripEmptyBlocks(parseConceptContent(content)),
    [content]
  );

  const editor = useCreateBlockNote({
    initialContent: blocks,
  });

  if (!content || content.trim() === "") {
    return <p className="text-gray-500 italic text-sm">No concept yet</p>;
  }

  return (
    <div className={className} data-rich-text-viewer data-variant={variant}>
      <BlockNoteView editor={editor} editable={false} theme="light" />
    </div>
  );
}
